import { Component, OnInit, AfterViewInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { WalkinApprovalService } from '../../../services/index';
import { WalkinApprovalModel } from '../../../model/index';
import swal from 'sweetalert2';
import * as moment from 'moment';
import * as _ from 'lodash';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Store } from '@ngrx/store';
import * as fromRootStore from '../../../reducers';
import * as fromCommonStore from '../../../store';

@Component({
    selector: 'walkin-approval-tab',
    templateUrl: './walkinApproval.component.html'
})
export class WalkinApprovalComponent implements OnInit, AfterViewInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    @ViewChild('walkinApprovalTable') walkinApprovalTable: any;
    @ViewChild('dateTemplate') dateTemplate: TemplateRef<any>;
    @ViewChild('statusTemplate') statusTemplate: TemplateRef<any>;
    @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;
    @ViewChild('rejectModal') rejectModalTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    recordList: WalkinApprovalModel[] = [];
    loadingIndicator = true;
    reorderable = true;
    isLoadMask: Promise<any>;

    filterData = {
        fromDate: moment().startOf('month').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        status: 'Pending',
        statusDisplay: 'Pending',
        branch_id: '',
        branchDisplay: '',
        search: ''
    };

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'wa.walkin_approval_id',
        orderDir: 'DESC'
    };

    rejectModalRef: BsModalRef;
    rejectData = { walkin_approval_id: 0, rejection_reason: '' };
    isRejectLoading = false;

    viewData: any = null;
    viewDisplayRows: { label: string, value: string }[] = [];
    viewModalRef: BsModalRef;

    statusOptions = [
        { val: '', label: 'All' },
        { val: 'Pending', label: 'Pending' },
        { val: 'Approved', label: 'Approved' },
        { val: 'Rejected', label: 'Rejected' }
    ];

    branchList: any[] = [];
    isAdmin = false;

    constructor(
        private walkinApprovalService: WalkinApprovalService,
        private toasterService: ToasterService,
        private modalService: BsModalService,
        private store: Store<fromRootStore.State>
    ) { }

    ngOnInit() {
        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) { return; }
            this.branchList = _.filter(res.data, (obj) => obj['is_crm_branch'] === 'Yes');
        });
        this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin']) {
                this.isAdmin = auth['usertype'] === 'Super_Admin' || auth['usertype'] === 'Admin';
            }
        });
    }

    ngAfterViewInit() {
        setTimeout(() => {
        this.columns = [
            { prop: 'walkin_approval_id', name: '#', width: 90, sortable: true },
            { prop: 'client_no', name: 'Client No.', width: 140, sortable: true },
            { prop: 'client_name', name: 'Client Name', width: 180, sortable: true },
            { name: 'Walk-In Date', cellTemplate: this.dateTemplate, width: 180, sortable: false },
            { prop: 'page_type', name: 'Page Type', width: 180, sortable: true },
            { prop: 'requested_by_name', name: 'Requested By', width: 180, sortable: false },
            { prop: 'requested_on', name: 'Requested On', width: 180, sortable: true },
            { name: 'Status', cellTemplate: this.statusTemplate, width: 140, sortable: false },
            { name: 'Action', cellTemplate: this.actionTemplate, width: 180, sortable: false }
        ];
        this.pageCallback({ offset: 0 });
        });
    }

    onOpenedFilter() {
        setTimeout(() => { }, 100);
    }

    onSelectStatus(s: any) {
        this.filterData.status = s.val;
        this.filterData.statusDisplay = s.label;
    }

    onSelectBranch(b: any) {
        this.filterData.branch_id = b.branch_id;
        this.filterData.branchDisplay = b.branch_name;
    }

    clearFilter() {
        this.filterData = {
            fromDate: moment().startOf('month').format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
            status: 'Pending',
            statusDisplay: 'Pending',
            branch_id: '',
            branchDisplay: '',
            search: ''
        };
        this.page.offset = 0;
        this.loadList();
        this.filterPanel.close();
    }

    applyFilter() {
        this.page.offset = 0;
        this.loadList();
        this.filterPanel.close();
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.loadList();
    }

    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[] }) {
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.loadList();
    }

    onChangePageSize(limit: number) {
        this.page.limit = limit;
        this.loadList();
    }

    loadList() {
        this.loadingIndicator = true;
        const query = {
            start: this.page.offset,
            limit: this.page.limit,
            orderColumn: this.page.orderBy,
            orderDir: this.page.orderDir,
            fromDate: this.filterData.fromDate,
            toDate: this.filterData.toDate,
            status: this.filterData.status,
            branch_id: this.filterData.branch_id,
            search: this.filterData.search
        };
        this.isLoadMask = this.walkinApprovalService.getList(query).then(res => {
            this.loadingIndicator = false;
            if (res && res.success) {
                this.recordList = res.data;
                this.page.count = res.totCnt;
            } else {
                this.recordList = [];
            }
        }).catch(() => { this.loadingIndicator = false; });
    }

    onApprove(row: any) {
        swal({
            title: 'Approve Entry?',
            html: `Approve walk-in entry for <strong>${row.client_name}</strong> on ${moment(row.walkin_date).format('DD-MMM-YYYY')}?`,
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#10b981',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Yes, Approve',
            cancelButtonText: 'Cancel'
        }).then(() => {
            const approvalId = row['walkin_approval_id'];
            this.walkinApprovalService.approve({ walkin_approval_id: approvalId }).then(res => {
                if (res && res.success) {
                    this.toasterService.pop('success', 'Approved', res.message || 'Entry approved successfully');
                    this.loadList();
                } else {
                    this.toasterService.pop('error', 'Error', res && res.message ? res.message : 'Approval failed');
                }
            }).catch(err => {
                this.toasterService.pop('error', 'Error', 'Approval request failed');
            });
        }, () => { });
    }

    onReject(row: any, template: TemplateRef<any>) {
        this.rejectData = { walkin_approval_id: row.walkin_approval_id, rejection_reason: '' };
        this.rejectModalRef = this.modalService.show(template, { class: 'modal-sm' });
    }

    doReject() {
        if (!this.rejectData.rejection_reason || this.rejectData.rejection_reason.trim() === '') {
            this.toasterService.pop('warning', 'Required', 'Please enter a rejection reason');
            return;
        }
        this.isRejectLoading = true;
        this.walkinApprovalService.reject(this.rejectData).then(res => {
            this.isRejectLoading = false;
            if (res && res.success) {
                this.rejectModalRef.hide();
                this.toasterService.pop('success', 'Rejected', res.message || 'Entry rejected');
                this.loadList();
            } else {
                this.toasterService.pop('error', 'Error', res && res.message ? res.message : 'Rejection failed');
            }
        }).catch(() => { this.isRejectLoading = false; });
    }

    onView(row: any, template: TemplateRef<any>) {
        this.walkinApprovalService.getDetail({ walkin_approval_id: row.walkin_approval_id }).then(res => {
            if (res && res.success) {
                this.viewData = res.data;
                try {
                    const d = JSON.parse(res.data.walkin_data);
                    const arr: { label: string, value: string }[] = [];
                    const add = (label: string, val: any) => {
                        const v = (val !== null && val !== undefined) ? String(val).trim() : '';
                        if (v !== '') { arr.push({ label, value: v }); }
                    };
                    add('Walk-In Status', Array.isArray(d.status) ? d.status.join(', ') : d.status);
                    add('Walk-In Type', d.walk_in_type);
                    add('Reference', d.ref_name || d.reference);
                    add('Description', d.description);
                    add('Potential Customer', d.potential_customer);
                    add('Bill Generation', d.bill_gen);
                    add('Testing', d.promo_testing || d.testing);
                    add('Trial', d.promo_trail || d.trail);
                    add('Promo', d.promo);
                    add('Follow-Up Status', d.followup_status);
                    add('Client Feedback', d.client_feedback);
                    add('Call Type', d.call_type);
                    add('Store Promo', d.store_promo);
                    add('Doctor Type', d.doctor_type);
                    this.viewDisplayRows = arr;
                } catch (e) { this.viewDisplayRows = []; }
                this.viewModalRef = this.modalService.show(template, { class: 'modal-lg modal-dialog-scrollable' });
            }
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/walkinApproval/walkinApproval.component.ts